import React, { useMemo } from 'react';
import Reserve from '../components/Reserve/Reserve';
import Container from '../components/ui/Container/Container';
import WidgetContainer from '../components/ui/WidgetContainer/WidgetContainer';
import { useInfoWidgetService } from '../services/info-widget-service';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../services/query-keys';
import { EInfoWidgetType, IInfoWidget } from '../shared/IInfoWidget';
import PageHeading from '../components/ui/PageHeading/PageHeading';
import { useAuthContext } from '../context/auth-context';
import classes from './ReservePage.module.scss';

const ReservePage: React.FC = () => {
  const { user } = useAuthContext();
  const { fetchInfoWidgets } = useInfoWidgetService();
  
  const { data: widgets } = useQuery({
    queryKey: [QueryKey.infoWidgets],
    queryFn: fetchInfoWidgets,
    enabled: !!user,
  });

  const { bannerWidgets, sidebarWidgets, footerWidgets } = useMemo(() => {
    if (!widgets) return { bannerWidgets: [], sidebarWidgets: [], footerWidgets: [] };
    
    const visibleWidgets = [...widgets]
      .filter(w => w.isVisible)
      .sort((a, b) => a.ordering - b.ordering);

    return {
      bannerWidgets: visibleWidgets.filter(w => w.type === EInfoWidgetType.BANNER),
      sidebarWidgets: visibleWidgets.filter(w => w.type === EInfoWidgetType.SIDEBAR),
      footerWidgets: visibleWidgets.filter(w => w.type === EInfoWidgetType.FOOTER),
    };
  }, [widgets]);

  const renderWidgets = (widgetList: IInfoWidget[]) => (
    <>
      {widgetList.map(widget => (
        <WidgetContainer 
          key={widget.id} 
          title={widget.title || "Important Information"}
        >
          <div dangerouslySetInnerHTML={{ __html: widget.content }} />
        </WidgetContainer>
      ))}
    </>
  );

  return (
    <>
      <PageHeading>Select dates and locations</PageHeading>
      <div className={classes.ReservePage}>
        <div className={classes.Layout}>
        <div className={classes.Main}>
          {bannerWidgets.length > 0 && (
            <div className={classes.Banner}>
              {renderWidgets(bannerWidgets)}
            </div>
          )}
          <Container className={classes.MainContainer}>
            <Reserve />
          </Container>
          <div className={classes.SidebarMobile}>
            {renderWidgets(sidebarWidgets)}
          </div>
          {footerWidgets.length > 0 && (
            <div className={classes.Footer}>
              {renderWidgets(footerWidgets)}
            </div>
          )}
        </div>
        <div className={classes.Sidebar}>
          {renderWidgets(sidebarWidgets)}
        </div>
      </div>
    </div>
    </>
  );
};

export default ReservePage;
